import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../../../Common';

export default function PoolProject({
  token_icon: tokenImage,
  token_name: tokenName,
  token_symbol: tokenSymbol,
  onEdit,
  ...rest
}) {
  return (
    <div className="pool-project">
      <div className="left-side-wrapper">
        <img src={tokenImage} alt="" className="circled" />
        <span className="token-name">{tokenName}</span>
        <span className="token-symbol">{tokenSymbol}</span>
      </div>
      <div className="right-side-wrapper">
        <Button
          onClick={() => onEdit({ ...rest, token_icon: tokenImage, token_name: tokenName, token_symbol: tokenSymbol })}
          text="common.edit"
          className="outlined-btn"
        />
      </div>
    </div>
  );
}

PoolProject.propTypes = {
  token_icon: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  token_name: PropTypes.string.isRequired,
  token_symbol: PropTypes.string.isRequired,
};
